export const API = process.env.VUE_APP_API;
export const MONTHS_BEFORE_EXPIRE_CARD_WARNING = 1;
export const COGNITO_USER_POOL_ID = process.env.VUE_APP_AWS_COGNITO_USER_POOL_ID;
export const COGNITO_WEB_CLIENT_ID = process.env.VUE_APP_AWS_COGNITO_WEB_CLIENT_ID;
export const COGNITO_REGION = process.env.VUE_APP_AWS_REGION;
export const COGNITO_DOMAIN = process.env.VUE_APP_AWS_COGNITO_DOMAIN;
// We use this as part of the name you see in your authenticator app so you can tell
// the one for DEV from QA, UAT or PROD
export const COGNITO_ENV = process.env.VUE_APP_AWS_COGNITO_ENVIRONMENT;
